import LeaveRestrictionTypes from './leaveRestriction.types';

// Fetch Leave Restrictions Actions
export const fetchLeaveRestrictionsStart = (data?: any) => ({
	type: LeaveRestrictionTypes.FETCH_LEAVE_RESTRICTIONS_START,
	payload: data,
});

export const fetchLeaveRestrictionsSuccess = (data: any) => ({
	type: LeaveRestrictionTypes.FETCH_LEAVE_RESTRICTIONS_SUCCESS,
	payload: data,
});

export const fetchLeaveRestrictionsFailure = (error: unknown) => ({
	type: LeaveRestrictionTypes.FETCH_LEAVE_RESTRICTIONS_FAILURE,
	payload: error,
});

// Create Leave Restriction Actions
export const createLeaveRestrictionStart = (data: any) => ({
	type: LeaveRestrictionTypes.CREATE_LEAVE_RESTRICTION_START,
	payload: data,
});

export const createLeaveRestrictionSuccess = (data: any) => ({
	type: LeaveRestrictionTypes.CREATE_LEAVE_RESTRICTION_SUCCESS,
	payload: data,
});

export const createLeaveRestrictionFailure = (error: unknown) => ({
	type: LeaveRestrictionTypes.CREATE_LEAVE_RESTRICTION_FAILURE,
	payload: error,
});

// Update Leave Restriction Actions
export const updateLeaveRestrictionStart = (data: any) => ({
	type: LeaveRestrictionTypes.UPDATE_LEAVE_RESTRICTION_START,
	payload: data,
});

export const updateLeaveRestrictionSuccess = (data: any) => ({
	type: LeaveRestrictionTypes.UPDATE_LEAVE_RESTRICTION_SUCCESS,
	payload: data,
});

export const updateLeaveRestrictionFailure = (error: unknown) => ({
	type: LeaveRestrictionTypes.UPDATE_LEAVE_RESTRICTION_FAILURE,
	payload: error,
});

// Delete Leave Restriction Actions
export const deleteLeaveRestrictionStart = (restrictLeaveID: number) => ({
	type: LeaveRestrictionTypes.DELETE_LEAVE_RESTRICTION_START,
	payload: restrictLeaveID,
});

export const deleteLeaveRestrictionSuccess = (restrictLeaveID: number) => ({
	type: LeaveRestrictionTypes.DELETE_LEAVE_RESTRICTION_SUCCESS,
	payload: restrictLeaveID,
});

export const deleteLeaveRestrictionFailure = (error: unknown) => ({
	type: LeaveRestrictionTypes.DELETE_LEAVE_RESTRICTION_FAILURE,
	payload: error,
});

// Unpublish Leave Restriction Actions
export const unpublishLeaveRestrictionStart = (restrictLeaveID: number) => ({
	type: LeaveRestrictionTypes.UNPUBLISH_LEAVE_RESTRICTION_START,
	payload: restrictLeaveID,
});

export const unpublishLeaveRestrictionSuccess = (restrictLeaveID: number) => ({
	type: LeaveRestrictionTypes.UNPUBLISH_LEAVE_RESTRICTION_SUCCESS,
	payload: restrictLeaveID,
});

export const unpublishLeaveRestrictionFailure = (error: unknown) => ({
	type: LeaveRestrictionTypes.UNPUBLISH_LEAVE_RESTRICTION_FAILURE,
	payload: error,
});

// Publish Leave Restriction Actions
export const publishLeaveRestrictionStart = (restrictLeaveID: number) => ({
	type: LeaveRestrictionTypes.PUBLISH_LEAVE_RESTRICTION_START,
	payload: restrictLeaveID,
});

export const publishLeaveRestrictionSuccess = (restrictLeaveID: number) => ({
	type: LeaveRestrictionTypes.PUBLISH_LEAVE_RESTRICTION_SUCCESS,
	payload: restrictLeaveID,
});

export const publishLeaveRestrictionFailure = (error: unknown) => ({
	type: LeaveRestrictionTypes.PUBLISH_LEAVE_RESTRICTION_FAILURE,
	payload: error,
});
